// extracted by mini-css-extract-plugin
module.exports = {"container":"text_container__MsP_q","filter":"text_filter__CVWXc","animatedLabel":"text_animatedLabel__ErGrk","focus":"text_focus__t8HAi","inputField":"text_inputField__mRGj9"};